export default __webpack_public_path__ + "static/media/SME.6a879249.png";